import { useState, useEffect, useCallback } from "react";
import apiFetch from "../../../../shared/services/apiClient";

/**
 * Carga el resumen agregado de CxC por filial desde el backend.
 * El servidor hace GROUP BY + SUM en la base de datos; el frontend
 * solo recibe una fila por filial (no todos los registros CxC).
 */
export function useCxcFiliales(filtro, search, refreshKey) {
  const [filas, setFilas] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res  = await apiFetch("/api/finance/cuentaXCobrar/dashboard-summary/");
      const data = await res.json();
      // data ya viene como [{filialId, filialLabel, propietario, totalMonto, totalAbono, totalSaldo, cantFacturas}]
      let lista = Array.isArray(data) ? data : [];

      if (filtro === "debiendo") {
        lista = lista.filter((r) => r.totalSaldo > 0);
      } else if (filtro === "aldia") {
        lista = lista.filter((r) => r.totalSaldo <= 0);
      }

      if (search.trim()) {
        const q = search.trim().toLowerCase();
        lista = lista.filter(
          (r) =>
            r.filialLabel.toLowerCase().includes(q) ||
            r.propietario.toLowerCase().includes(q),
        );
      }

      lista.sort((a, b) => b.totalSaldo - a.totalSaldo);
      setFilas(lista);
    } catch (e) {
      console.error("Error cargando resumen CxC:", e);
    } finally {
      setLoading(false);
    }
  }, [filtro, search, refreshKey]);

  useEffect(() => {
    load();
  }, [load]);

  return { filas, loading, refetch: load };
}
